import { render, staticRenderFns } from "./SortingColumn.vue?vue&type=template&id=84a0477a&scoped=true&"
import script from "./SortingColumn.vue?vue&type=script&lang=ts&"
export * from "./SortingColumn.vue?vue&type=script&lang=ts&"
import style0 from "./SortingColumn.vue?vue&type=style&index=0&id=84a0477a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a0477a",
  null
  
)

export default component.exports